import React from 'react'
import { useState } from 'react';
import { icons } from "../../assets";
import { CustomModal } from '../../components';
import { TableUserDetails } from "./index"

export const TemplateDetailUser = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const [modalOpend, setModalOpend] = useState(false)
    return (
        <>
            <img
                onClick={() => setModalOpend(true)}
                src={icons.moreInfo} className="w-6 cursor-pointer" alt="info" />
            <CustomModal
                key={"usrDetails"}
                isVisible={modalOpend}
                close={() => setModalOpend(false)}
                title={"Detalles"}
                width={"912px"}
                height={"520px"}
            >
                <TableUserDetails nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></TableUserDetails>
            </CustomModal>
        </>

    )

}

export default TemplateDetailUser

